// Navigation des Moduls `profil` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul profil.
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'profil',
  title: 'My performance',
});
